// Central data source for PAHI TECHNOCRATE PVT. LTD.

export const COMPANY = {
  name: "PAHI TECHNOCRATE PVT. LTD.",
  shortName: "PAHI",
  tagline: "Precision Engineered. Performance Assured.",
  experience: "5+",
  workforce: "100+",
  logo: "/brand/pahi-logo.webp",
  ceo: "/brand/ceo1.webp",
  address: {
    line1: "F-25, EPIP, RIICO Industrial Area",
    line2: "Neemrana, Dist. Kotputli-Behror",
    line3: "Rajasthan – 301705, India",
    full: "F-25, EPIP, RIICO Industrial Area, Neemrana, Dist. Kotputli-Behror, Rajasthan – 301705",
  },
  whatsapp: "919829803123",
  whatsappDisplay: "+91 98298 03123",
  phones: ["+91 98298 03123", "+91 92612 00890"],
  emails: ["ajay@pahi.co.in", "info@pahi.co.in"],
  mapEmbed:
    "https://www.google.com/maps?q=F-25,+EPIP,+RIICO+Industrial+Area,+Neemrana,+Kotputli-Behror,+Rajasthan+301705&output=embed",
  mapDirections:
    "https://www.google.com/maps/dir/?api=1&destination=F-25%2C+EPIP%2C+RIICO+Industrial+Area%2C+Neemrana%2C+Kotputli-Behror%2C+Rajasthan+301705",
};

export const ISO_CERTS = [
  { code: "ISO 9001:2015", label: "Quality Management" },
  { code: "ISO 14001:2015", label: "Environmental Management" },
  { code: "ISO 45001:2018", label: "Occupational Health & Safety" },
];

export const STATS = [
  { value: 5, suffix: "+", label: "Years of Excellence" },
  { value: 100, suffix: "+", label: "Skilled Workforce" },
  { value: 20, suffix: "+", label: "Advanced Machines" },
  { value: 100, suffix: "%", label: "Quality Assured" },
];

export const MACHINES = [
  {
    slug: "nct-punching",
    name: "NCT Turret Punch Press",
    image: "/machinery/nct-punching.webp",
    make: "AMADA (Japan)",
    model: "AE255NT & AE2510NT",
    tagline: "High-speed CNC turret punching",
    description:
      "Japanese AMADA CNC turret punch presses delivering ultra-precise perforations, forms and louvers on sheet metal at high throughput.",
    specs: [
      { k: "Capacity", v: "200 KN (up to 6 mm)" },
      { k: "Working Range", v: "6000 × 1500 × 6 mm" },
      { k: "Units", v: "2 Nos" },
    ],
    applications: ["HVAC Parts", "Data Center Parts", "Enclosures", "Electrical panels", "Perforated sheets", "Chassis parts"],
    benefits: ["Repeatable precision", "High tooling flexibility", "Fast cycle times"],
  },
  {
    slug: "laser-cutting",
    name: "CNC Laser Cutting",
    image: "/machinery/laser-cutting.webp",
    make: "SLTL / Tailift",
    model: "Fiber Laser 6 kW",
    tagline: "Clean, burr-free contour cutting",
    description:
      "6 kW fiber laser cutting for intricate profiles across a wide thickness range with mirror-clean edges and tight tolerances.",
    specs: [
      { k: "Power", v: "6 kW" },
      { k: "Sheet Cutting", v: "0.5 mm to 25 mm" },
      { k: "Tube Length", v: "6 m, pipe dia up to 250 mm" },
    ],
    applications: ["Precision profiles", "Prototypes", "Tube & pipe cutting", "Complex geometries"],
    benefits: ["No tooling cost", "Micron-level accuracy", "Minimal heat distortion"],
  },
  {
    slug: "power-press",
    name: "Power Press 20–400 Ton",
    image: "/machinery/power-press.webp",
    make: "ISGEC Rhino",
    model: "GZ-300T",
    tagline: "High-tonnage precision stamping",
    description:
      "Pneumatic and mechanical power presses from 20 to 400 tons for blanking, forming and deep-draw stamping of components.",
    specs: [
      { k: "Capacity", v: "20 – 400 Ton" },
      { k: "Process", v: "Blanking / Forming / Draw" },
      { k: "Automation", v: "Die-safety & feed ready" },
    ],
    applications: ["HVAC Parts", "Data Center Parts", "Mass production parts", "Brackets", "Stamped components", "Deep-drawn parts"],
    benefits: ["High-volume output", "Consistent forming", "Cost-efficient at scale"],
  },
  {
    slug: "press-brake",
    name: "CNC Press Brake",
    image: "/machinery/press-brake.webp",
    make: "Hindustan Hydraulics",
    model: "HAWK 150-31",
    tagline: "Precision CNC bending",
    description:
      "Hindustan Hydraulics CNC-controlled hydraulic press brakes producing accurate, repeatable bends with programmable back-gauges for complex bend sequences.",
    specs: [
      { k: "Capacity", v: "150 Ton" },
      { k: "Working Range", v: "3100 mm" },
      { k: "Units", v: "3 Nos" },
    ],
    applications: ["Sheet metal bending", "Enclosures", "Panels", "Structural profiles"],
    benefits: ["Angle repeatability", "Multi-bend programming", "Consistent quality"],
  },
  {
    slug: "shearing",
    name: "Hydraulic Shearing",
    image: "/machinery/shearing.webp",
    make: "Hindustan Hydraulics",
    model: "GS 3106",
    tagline: "Clean straight-edge shearing",
    description:
      "Heavy-duty hydraulic shearing machines producing burr-free straight cuts for accurate blank preparation and material sizing.",
    specs: [
      { k: "Working Range", v: "3000 × 1250 × 6 mm" },
      { k: "Type", v: "Hydraulic Guillotine" },
      { k: "Edge", v: "Burr-free finish" },
    ],
    applications: ["Blank preparation", "Sheet sizing", "Strip cutting"],
    benefits: ["Fast material prep", "Accurate dimensions", "Clean edges"],
  },
  {
    slug: "spot-welding",
    name: "Spot & Projection Welding",
    image: "/machinery/spot-welding.webp",
    make: "PAHI Facility",
    model: "Spot cum Projection",
    tagline: "Strong, clean resistance welds",
    description:
      "Resistance spot and projection welding stations delivering strong, aesthetically clean joints for assembled sheet metal products.",
    specs: [
      { k: "Process", v: "Spot + Projection" },
      { k: "Control", v: "Programmable timers" },
      { k: "Finish", v: "Clean joints" },
    ],
    applications: ["Fabricated assemblies", "Panels", "Enclosures", "Brackets"],
    benefits: ["High joint strength", "Repeatable welds", "Minimal finishing"],
  },
  {
    slug: "mig-tig-welding",
    name: "MIG & TIG Welding",
    image: "/machinery/mig-tig-welding.webp",
    make: "Panasonic",
    model: "YD-250KR2",
    tagline: "Complete fabrication setup",
    description:
      "Panasonic MIG and TIG welding stations with a complete fabrication setup for precision joining of steel, stainless steel and aluminium.",
    specs: [
      { k: "Process", v: "MIG + TIG" },
      { k: "Materials", v: "MS / SS / Aluminium" },
      { k: "Setup", v: "Full fabrication line" },
    ],
    applications: ["Structural fabrication", "Frames", "Assemblies", "Custom fabrication"],
    benefits: ["Clean aesthetic welds", "Multi-material capability", "Certified quality"],
  },
  {
    slug: "fabrication",
    name: "Fabrication & Assembly",
    image: "/machinery/fabrication.webp",
    make: "PAHI Facility",
    model: "Structural Fabrication",
    tagline: "Heavy & precision fabrication",
    description:
      "Complete in-house fabrication capability — cutting, grinding, welding, structural assembly and finishing of steel frames, skids and custom industrial structures.",
    specs: [
      { k: "Scope", v: "Cutting / Grinding / Welding" },
      { k: "Structures", v: "Frames / Skids / Assemblies" },
      { k: "Materials", v: "MS / SS / Aluminium" },
    ],
    applications: ["Structural frames", "Skids & bases", "Enclosure fabrication", "Custom assemblies"],
    benefits: ["End-to-end fabrication", "Skilled workmanship", "Consistent quality"],
  },
  {
    slug: "vmc",
    name: "VMC Machining Centre",
    image: "/machinery/vmc.webp",
    make: "Batliboi",
    model: "Chetak 80 MC",
    tagline: "3-axis precision milling",
    description:
      "Vertical machining centres for high-accuracy milling, drilling and tapping of machined components and in-house tooling.",
    specs: [
      { k: "Type", v: "Vertical Machining Centre" },
      { k: "Use", v: "Milling / Drilling / Tapping" },
      { k: "Capability", v: "Tight tolerances" },
    ],
    applications: ["Machined components", "Tooling", "Fixtures", "Precision parts"],
    benefits: ["High accuracy", "Complex geometry", "In-house tooling"],
  },
  {
    slug: "cnc",
    name: "CNC Turning",
    image: "/machinery/cnc.webp",
    make: "Batliboi",
    model: "Sprint 16 Linear",
    tagline: "Precision turned components",
    description:
      "CNC turning centres producing accurate cylindrical and turned components with excellent surface finish and repeatability.",
    specs: [
      { k: "Type", v: "CNC Turning Centre" },
      { k: "Units", v: "2 Nos" },
      { k: "Finish", v: "Superior surface finish" },
    ],
    applications: ["Turned parts", "Shafts", "Bushes", "Precision components"],
    benefits: ["Repeatable accuracy", "Fine finish", "High productivity"],
  },
  {
    slug: "tool-room",
    name: "Tool Room Facility",
    image: "/machinery/vmc.webp",
    make: "In-house",
    model: "VMC, CNC, Lathe, Surface Grinder, Bandsaw",
    tagline: "In-house tooling manufacturing",
    description:
      "A fully equipped tool room with VMC, CNC, lathe, MNTR, surface grinder and bandsaw for complete in-house die and tooling manufacturing.",
    specs: [
      { k: "Equipment", v: "VMC / CNC-2 / Lathe" },
      { k: "Also", v: "MNTR / Surface Grinder / Bandsaw" },
      { k: "Capability", v: "In-house tooling" },
    ],
    applications: ["Die manufacturing", "Fixtures", "Jigs", "Tool maintenance"],
    benefits: ["Faster tooling", "Full control", "Cost efficiency"],
  },
  {
    slug: "powder-coating",
    name: "Powder Coating — 9 Stage PT",
    image: "/machinery/powder-coating.webp",
    make: "Gema",
    model: "9 Process PT Tank",
    tagline: "Durable, uniform finishing",
    description:
      "Powder coating plant with a 9-stage pre-treatment tank process delivering corrosion-resistant, uniform and durable surface finishes.",
    specs: [
      { k: "Process", v: "9-Stage Pre-treatment" },
      { k: "Specification", v: "4500 × 3500 × 2500 mm" },
      { k: "Finish", v: "Uniform & durable" },
    ],
    applications: ["Finished enclosures", "Panels", "Structural parts", "Consumer products"],
    benefits: ["Corrosion resistance", "Premium finish", "Long life coating"],
  },
  {
    slug: "quality-inspection",
    name: "Quality Inspection Lab",
    image: "/machinery/quality-inspection.webp",
    make: "Metrology",
    model: "Final Inspection Station",
    tagline: "Strict quality control",
    description:
      "A dedicated final inspection station equipped with precision metrology instruments and documented quality procedures — ensuring every component meets tight dimensional tolerances and international quality standards.",
    specs: [
      { k: "Function", v: "Dimensional inspection" },
      { k: "Standard", v: "ISO 9001:2015" },
      { k: "Stage", v: "In-process + Final" },
    ],
    applications: ["Incoming inspection", "In-process checks", "Final QC", "Inspection reports"],
    benefits: ["Zero-defect focus", "Full traceability", "Certified quality"],
  },
];

export const SERVICES = [
  { title: "Precision Sheet Metal Manufacturing", icon: "Layers", desc: "End-to-end fabrication of high-precision sheet metal components." },
  { title: "Fabrication Services", icon: "Wrench", desc: "Complete fabrication with cutting, bending, welding and assembly." },
  { title: "Machining Components", icon: "Cog", desc: "CNC & VMC machined components with tight tolerances." },
  { title: "Laser Cutting", icon: "Zap", desc: "Fiber laser cutting for intricate, burr-free profiles." },
  { title: "Tool Room Development", icon: "Hammer", desc: "In-house die, jig and fixture manufacturing." },
  { title: "Power Press Components", icon: "Gauge", desc: "High-tonnage stamped and formed components." },
  { title: "Precision Bending", icon: "FoldVertical", desc: "CNC press brake bending with repeatable accuracy." },
  { title: "Spot Welding", icon: "Dot", desc: "Resistance spot & projection welding for assemblies." },
  { title: "MIG Welding", icon: "Flame", desc: "Strong, clean MIG welds across materials." },
  { title: "TIG Welding", icon: "Sparkles", desc: "Precision TIG welding for critical joints." },
  { title: "Powder Coating", icon: "Paintbrush", desc: "9-stage pre-treatment durable coating." },
  { title: "Assembly Support", icon: "PackageCheck", desc: "Sub-assembly and final assembly support." },
  { title: "Industrial Manufacturing Solutions", icon: "Factory", desc: "End-to-end OEM manufacturing partnerships." },
];

export const SERVICE_HIGHLIGHTS = [
  "24 Hours Online Customer Support",
  "Professional Engineering Services",
  "Reliable Manufacturing Quality",
  "High Product Efficiency",
  "On-Time Delivery",
  "Fast Production Planning",
  "Mass Production Capability",
  "Prototype Development",
  "OEM Manufacturing Support",
  "End-to-End Manufacturing Solutions",
];

export const WHY_CHOOSE = [
  { title: "Advanced Japanese Machinery", icon: "Cpu", desc: "AMADA & Panasonic precision equipment." },
  { title: "ISO Certified Manufacturing", icon: "BadgeCheck", desc: "9001, 14001 & 45001 certified processes." },
  { title: "Skilled Engineering Team", icon: "Users", desc: "100+ trained manufacturing professionals." },
  { title: "High Precision Production", icon: "Target", desc: "Micron-level tolerances, every part." },
  { title: "Modern Manufacturing Technology", icon: "Cog", desc: "CNC-driven, automated production lines." },
  { title: "Strict Quality Inspection", icon: "SearchCheck", desc: "In-process and final QC at every stage." },
  { title: "Competitive Pricing", icon: "TrendingDown", desc: "Optimized costs without compromise." },
  { title: "Reliable Delivery", icon: "Truck", desc: "On-time, every time, at scale." },
  { title: "Customer Satisfaction", icon: "Handshake", desc: "Partnerships built on trust." },
  { title: "Long-Term Partnership", icon: "Infinity", desc: "We grow with our clients." },
];

export const PROCESS = [
  { step: "01", title: "Raw Material", desc: "Certified sheet & tube inward inspection." },
  { step: "02", title: "Laser Cutting", desc: "Fiber laser precision profiling." },
  { step: "03", title: "NCT Punching", desc: "CNC turret forms & perforations." },
  { step: "04", title: "Shearing", desc: "Burr-free straight-edge blank preparation." },
  { step: "05", title: "Power Press", desc: "Blanking, forming & stamping." },
  { step: "06", title: "Press Brake Bending", desc: "CNC repeatable bending." },
  { step: "07", title: "Welding", desc: "Spot / MIG / TIG joining." },
  { step: "08", title: "CNC / VMC Machining", desc: "Precision machined features." },
  { step: "09", title: "Powder Coating", desc: "9-stage durable finishing." },
  { step: "10", title: "Quality Inspection", desc: "Dimensional & visual QC." },
  { step: "11", title: "Packing", desc: "Protective industrial packaging." },
  { step: "12", title: "Dispatch", desc: "On-time logistics & delivery." },
];

export const CUSTOMERS = [
  "KRN Heat Exchangers",
  "Trans ACNR",
  "Vakio India",
  "Helios",
  "Lavish Surfaces",
  "Beecon Electric",
  "Ferraria Metal Industries",
];

export const INDUSTRIES = [
  "OEMs",
  "HVAC",
  "Automotive",
  "EV Manufacturers",
  "Electrical",
  "Telecom",
  "Industrial Equipment",
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Machinery", to: "/machinery" },
  { label: "Services", to: "/services" },
  { label: "Products", to: "/products" },
  { label: "Process", to: "/process" },
  { label: "Contact", to: "/inquiry" },
];

export const PRODUCTS = [
  {
    category: "Sheet Metal & Fabrication",
    icon: "Layers",
    items: [
      "HVAC Parts & Ducting",
      "Communication Junction Boxes",
      "Meter Boxes",
      "Electric Panel / MCB Box",
      "Server Racks",
      "E-Rickshaw Chassis",
      "Inverter Box",
      "Bus AC Grill",
      "Control Panels",
      "Air Blower",
      "Shoe Rack",
    ],
  },
  {
    category: "Machining Parts",
    icon: "Cog",
    items: [
      "Brass Bushes",
      "Distributors",
      "Cutting Tools",
      "Bending Tools",
      "Special Shape Tools",
      "Connecting Rods",
      "Lock Hinges",
    ],
  },
  {
    category: "Doors & Cabinets",
    icon: "DoorClosed",
    items: [
      "Fire Rated Doors",
      "Stainless Steel Doors",
      "Shaft Doors",
      "Rain Drain / Drainer",
      "Shower Drain",
      "Chimney",
    ],
  },
];

export const buildWhatsAppLink = (message) => {
  const base = `https://wa.me/${COMPANY.whatsapp}`;
  const text = encodeURIComponent(
    message ||
      "Hello PAHI TECHNOCRATE PVT. LTD. I would like to discuss a manufacturing requirement."
  );
  return `${base}?text=${text}`;
};
